import actionTypes from '../constants/action-types';

const setSingleTemplate = (template) => ({
  type: actionTypes.SET_SINGLE,
  payload: { template },
});

export default setSingleTemplate;
